import {breakpointDown} from "../utils/breakpoints";
import { gsap } from 'gsap'
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

$('.js-accordion-1-title').click(function(){
  let accordionContainer = $(this).closest('.js-accordion-1')
  let curEl = $(this).parent()
  let video = curEl.find('video')
  if (video.length) video[0].play()

  curEl.toggleClass('opened')
  curEl.find('.js-accordion-1-content').slideToggle()

  // close other accordions
  if (accordionContainer.length){
    accordionContainer.find('.js-accordion-1-el').each(function (i, el){
      if (el !== curEl[0]){
        $(el).removeClass('opened')
        $(el).find('.js-accordion-1-content').slideUp()

        let video = $(el).find('video')
        if (video.length){
          video[0].pause()
          video[0].currentTime = 0
        }

      }
    })
  }

  if (breakpointDown('xl')){
    setTimeout(function(){
      gsap.to(window, {duration: 0.4, scrollTo: curEl[0]});
    }, 400)
  }

})
